module.exports = __webpack_public_path__ + "static/LogoGira-33dccd9165fa067001f31b1374e91771.png";